import Vue from 'vue'

Vue.filter('capitalize', function (value) {
  if (value) {
    return value[0].toUpperCase() + value.slice(1)
  }
})

Vue.filter('upper', function (value) {
  if (value) {
    return value.toUpperCase()
  }
})
